<template>
  <div class="liveInfoInformation">
    <el-card  v-auth="'/liveInfoInformation/pageList'">
      <el-form ref="searchForm" :model="searchForm" :label-width="typeFormLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="24" :lg="8">
            <!-- -->
            <el-date-picker v-model="createTime" @change="createTimeChange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="下单开始日期" end-placeholder="下单结束日期" :picker-options="pickerOptions"></el-date-picker>
          </el-col>
          <!-- <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.name" placeholder="请输入直播名称" auto-complete="off" clearable></el-input>
          </el-col> -->
          <el-col :sm="24" :md="12" :lg="9" style="float:right">
            <div style="float:right" class="flex-starts">
              <el-button-group style="float:right">
                <el-button type="primary" @click="page.pageNumber=1,pageList(),liveDetail()"
                           icon="el-icon-search" v-auth="'/liveInfoInformation/pageList'">查询</el-button>
              </el-button-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px">
      <div class="liveInfoInformation_first" :key="num">
        <div class="liveInfoInformation_title"><span style="margin-left:8px">直播概况</span></div>
        <div class="liveInfoInformation_top">
          <div class="liveInfoInformation_box">
            <div class="liveInfoInformation_first_title">
              <div>观看次数</div>
              <!-- <div>
                <el-popover placement="top" width="400" trigger="hover">
                  <div>直播创建开始至今，进入直播间的学员总数</div>
                  <i slot="reference" class="iconfont icon-question-circle liveInfoInformation_icon"></i>
                </el-popover>
              </div> -->
            </div>
            <div class="liveInfoInformation_number">{{liveDetailInfo.countWatch}}次</div>
            <div>PC端：{{liveDetailInfo.pcVideoView || 0}}次 | 移动端：{{liveDetailInfo.mobileVideoView || 0}}次</div>
          </div>
          <div class="liveInfoInformation_box">
            <div class="liveInfoInformation_first_title">
              <div>观看时长</div>
              <!-- <div>
                <el-popover placement="top" width="400" trigger="hover">
                  <div>直播创建开始至今，学员进入直播间的总次数</div>
                  <i slot="reference" class="iconfont icon-question-circle liveInfoInformation_icon"></i>
                </el-popover>
              </div> -->
            </div>
            <div class="liveInfoInformation_number">{{liveDetailInfo.timeWatch}}分钟</div>
            <div>PC端：{{liveDetailInfo.pcPlayDuration || 0}}分钟 | 移动端：{{liveDetailInfo.mobilePlayDuration || 0}}分钟</div>
          </div>
          <div class="liveInfoInformation_box">
            <div class="liveInfoInformation_first_title">
              <div>观看人数</div>
              <!-- <div>
                <el-popover placement="top" width="400" trigger="hover">
                  <div>进入直播间学习的学员总数（更新频率为1天）</div>
                  <div>学习动作：</div>
                  <div>直播前：不统计</div>
                  <div>直播中：进入直播间</div>
                  <div>直播结束：播放语音或视频</div>
                  <i slot="reference" class="iconfont icon-question-circle liveInfoInformation_icon"></i>
                </el-popover>
              </div> -->
            </div>
            <div class="liveInfoInformation_number">{{liveDetailInfo.numberPeopleWatch}}次</div>
            <div>PC端：{{liveDetailInfo.pcUniqueViewer || 0}}次 | 移动端：{{liveDetailInfo.mobileUniqueViewer || 0}}次</div>
          </div>
        </div>
        <div class="liveInfoInformation_top">
          <div class="liveInfoInformation_box">
            <div class="liveInfoInformation_first_title">
              <div>人均观看时长</div>
              <!--<div>
                 <el-popover placement="top" width="400" trigger="hover">
                  <div>所有用户学习总时长/总观看人数（更新频率为1天)</div>
                  <div class="liveInfoInformation_popover_text">· 语音直播学习时长：直播中或结束后学员进入直播间的停留时长</div>
                  <div class="liveInfoInformation_popover_text">· 视频直播学习时长：直播中或结束学员进入直播间听课或播放视频时长</div>
                  <i slot="reference" class="iconfont icon-question-circle liveInfoInformation_icon"></i>
                </el-popover> 
              </div>-->
            </div>
            <div class="liveInfoInformation_number">{{liveDetailInfo.timeAverageWatch}}分钟</div>
            <!-- <div>PC端：6次 | 移动端：1次</div> -->
          </div>
          <div class="liveInfoInformation_box">
            <div class="liveInfoInformation_first_title">
              <div>人均观看次数</div>
              <!-- <div>
                <el-popover placement="top" width="400" trigger="hover">
                  <div>所有用户学习总累积消费（更新频率为1天)</div>
                  <div class="liveInfoInformation_popover_text">· 累积消费：直播中或结束后学员进入直播间的停留时长*单位分钟价格</div>
                  <i slot="reference" class="iconfont icon-question-circle liveInfoInformation_icon"></i>
                </el-popover>
              </div> -->
            </div>
            <div class="liveInfoInformation_number">{{liveDetailInfo.countAverageWatch}}次</div>
            <!-- <div>PC端：6次 | 移动端：1次</div> -->
          </div>
          <div class="liveInfoInformation_box" style="border-style: none;"></div>
        </div>

      </div>
      <div class="liveInfoInformation_two">
        <div class="liveInfoInformation_title"><span style="margin-left:8px">直播观看详情</span></div>

        <el-table :data="page.rows" border style="width: 100%;margin-top:20px;">
          <!-- <el-table-column prop="userName" label="用户昵称"></el-table-column> -->
          <!-- <el-table-column prop="name" label="在线时长"></el-table-column>
          <el-table-column prop="name" label="累计观看时长"></el-table-column> -->
          <!-- <el-table-column prop="currentDay" label="首次进入时间"></el-table-column> -->
          <!-- <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <i class="research-icon el-icon-download" @click="down(scope.row)"></i>
              <i class="research-icon el-icon-delete" @click="delect(scope.row)"></i>
            </template>
          </el-table-column> -->

          <!-- 新接口表格展示 -->
          <!-- <el-table-column prop="channelId" label="频道号"></el-table-column> -->
          <el-table-column prop="viewerName" label="用户名"></el-table-column>
          <el-table-column prop="logType" label="观看类型">
            <!-- 判断 -->
            <template slot-scope="scope">
              <span v-if="scope.row.logType == 'vod'">回访</span>
              <span v-else-if="scope.row.logType == 'live'">直播</span>
            </template>
          </el-table-column>
          <el-table-column prop="province" label="省份"></el-table-column>
          <el-table-column prop="city" label="城市"></el-table-column>
          <el-table-column prop="playDuration" label=" 播放时长"></el-table-column>
          <el-table-column prop="stayDuration" label="停留时长"></el-table-column>
          <el-table-column prop="flowSize" label="流量"></el-table-column>
          <el-table-column prop="isMobile" label="观看方式">
            <template slot-scope="scope">
              <span v-if="scope.row.isMobile == 'Y'">移动端</span>
              <span v-else-if="scope.row.isMobile == 'N'">PC端</span>
            </template>
          </el-table-column>
          <el-table-column prop="browser" label="浏览器"></el-table-column>
          <el-table-column prop="createdTime" label="观看开始时间"></el-table-column>
          <el-table-column prop="ipAddress" label="IP地址"></el-table-column>
        </el-table>

        <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      num: 0,
      liveLikesInfo: {},
      createTime: '',
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      liveDetailInfo: {},
      searchForm: {},
      typeFormLabelWidth: "100px",
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        },
          // {
          //   text: '最近三个月',
          //   onClick (picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit('pick', [start, end]);
          //   }
          // }
        ]
      },
    };
  },
  created () {
    // console.log(this.util.byteConversion(1024 * 1024));
    // console.log(this.util.formatDate(1622106954000, 'yyyy-MM-dd hh:mm:ss'), 'askjgkjh');
  },
  // mounted () {
  // this.liveLikes();
  // this.liveDetail();
  // this.pageList();
  // },
  methods: {
    createTimeChange (va) {
      // console.log(this.createTime, va, +this.createTime[1].slice(6, 7) - this.createTime[0].slice(6, 7));
      let dedDay = +this.createTime[1].slice(6, 7) - this.createTime[0].slice(6, 7);
      if (dedDay != 0) { this.$message.warning("不能跨月份查询"); return; }
      if (this.createTime) {
        // this.searchForm.date = this.createTime[0];
        this.searchForm.date = 'yyyy-MM-dd';
        this.searchForm.startTime = this.createTime[0];
        this.searchForm.endTime = this.createTime[1];
      } else {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      }
    },
    /*-------------------------------------获取直播信息---------------------------------- */
    liveLikes () {
      this.api.polyv
        .liveLikes({ idList: [this.$route.query.id] })
        .then((result) => {
          this.liveLikesInfo = result.data.channelLikes[0];
        });
    },
    liveDetail () {
      // this.searchForm.pageSize = this.page.pageSize;
      // this.searchForm.pageNumber = this.page.pageNumber;
      // this.searchForm.channelId = this.$route.query.channelId;
      // this.api.liveLog.liveDetail(this.searchForm).then((result) => {

      if (!this.searchForm.startTime || !this.searchForm.endTime) { this.$message.warning('请先选择时间段'); return; }
      let obj = {
        channelNumberIds: [this.$route.query.channelId],
        startDateV2: this.searchForm.startTime.split(' ')[0],
        endDateV2: this.searchForm.endTime.split(' ')[0],
      }

      this.api.liveLog.channelPlaySummaryV2(obj).then((res) => {
        if (res.success) { this.liveDetailInfo = res.data[0]; this.num++; }
        else this.$message.error(res.message);
        console.log(this.liveDetailInfo, 'this.liveDetailInfo');
        // this.page.rows = result.data.lpolyvChannelLogList.records;
        // this.page.total = result.data.lpolyvChannelLogList.total;
      });
    },
    pageList () {
      if (!this.searchForm.startTime || !this.searchForm.endTime) { this.$message.warning('请先选择时间段'); return; }
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.channelId = this.$route.query.channelId;
      // this.api.liveLog
      this.api.liveLog
        .viewLogPageV2(this.searchForm)
        .then((result) => {
          if (result.success) {
            this.page.rows = result.data.contents;
            this.page.rows.forEach((item, index) => {
              if (item.createdTime) item.createdTime = this.util.formatDate(item.createdTime, 'yyyy-MM-dd hh:mm:ss');
              if (item.flowSize) item.flowSize = this.util.byteConversion(item.flowSize);
              if (item.playDuration) item.playDuration = this.util.timeDiff(item.playDuration * 1000);
              if (item.stayDuration) item.stayDuration = this.util.timeDiff(item.stayDuration * 1000);
            })
            this.page.total = result.data.totalItems;
            this.page.pageSize = result.data.pageSize;
            this.page.pageNumber = result.data.currentPage;
          } else this.$message.error(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.liveDetail();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.liveDetail();
    },
  },
};
</script>
<style scoped>
.liveInfoInformation_top {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}
.liveInfoInformation_two {
  margin-top: 20px;
}
.liveInfoInformation_title {
  border-left: 2px solid #2a75ed;
}
.liveInfoInformation_box {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  -webkit-flex: 1;
  flex: 1;
  margin-right: 20px;
  padding: 20px;
}
.liveInfoInformation_box:nth-child(3) {
  margin-right: 0px;
}
.liveInfoInformation_icon {
  cursor: pointer;
}
.liveInfoInformation_first_title {
  display: flex;
  font-size: 16px;
  justify-content: space-between;
}
.liveInfoInformation_number {
  font-size: 30px;
  font-weight: 500;
  margin: 8px 0;
}
.liveInfoInformation_popover_text {
  font-size: 12px;
  color: #888888;
}
</style>



// WEBPACK FOOTER //
// src/components/liveInfo/liveInfoInformation.vue